import { render } from "./ReportCTA.vue?vue&type=template&id=51c13150&scoped=true"
import script from "./ReportCTA.vue?vue&type=script&lang=js"
export * from "./ReportCTA.vue?vue&type=script&lang=js"

import "./ReportCTA.vue?vue&type=style&index=0&id=51c13150&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c13150"]])

export default __exports__